export const ARTICLE_TYPE_OPTIONS = [
  { value: 'product_roundup', label: 'Product roundup' },
  { value: 'thought_leadership', label: 'Thought leadership' },
  { value: 'standalone_product_review', label: 'Standalone product review' },
  { value: 'company_focused_article', label: 'Company focused article' },
];
export const FOLLOW_OPTIONS = [
  { value: 'do_follow', label: 'Do follow' },
  { value: 'no_follow', label: 'No follow' },
];
export default {};
